import Header from '../../components/layout/Header';
import Body from '../../components/layout/Body';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import { useState, useRef } from '@wordpress/element';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Flex,
} from '@wordpress/components';
import { useNotice } from '../../contexts/NoticeContext';

const Tools = () => {
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const { showNotice } = useNotice();

    const exportData = async () => {
        try {
            const data = await apiFetch({ path: '/voxycure/v1/groups/export' });
            const blob = new Blob([JSON.stringify(data, null, 2)], {
                type: 'application/json',
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'voxycure-export.json';
            a.click();
        } catch (error) {
            showNotice(
                error?.message || __('Export failed!'),
                'error'
            );
        }
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleImport = async () => {
        if (!file) return;

        try {
            const text = await file.text();
            const data = JSON.parse(text);

            await apiFetch({
                path: '/voxycure/v1/groups/import',
                method: 'POST',
                data,
            });

            showNotice(__('Import successful!'), 'success');
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error) {
            showNotice(
                error?.message || __('Import failed. Please check your file.'),
                'error'
            );
        }
    };

    return (
        <>
            <Header>
                <h2 className='voxycure-editor__header-title'>
                    {__('Tools', 'voxycure-framework')}
                </h2>

                <Button
                    className='components-button is-primary voxycure-button'
                    isPrimary
                    onClick={exportData}
                >
                    {__('Export JSON', 'voxycure-framework')}
                </Button>
            </Header>

            <Body>
                <div className="voxy-settings-panel" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <Card>
                        <CardHeader>
                            <h3>{__('Import fields if you have any.', 'voxycure-framework')}</h3>
                        </CardHeader>
                        <CardBody>
                            <Flex align="center" gap="10">
                                <input
                                    type="file"
                                    accept="application/json"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    style={{ flex: '1' }}
                                />
                                <Button
                                    className='components-button is-primary voxycure-button'
                                    isSecondary
                                    isBusy={false}
                                    disabled={!file}
                                    onClick={handleImport}
                                >
                                    {__('Import JSON', 'voxycure-framework')}
                                </Button>
                            </Flex>
                        </CardBody>
                    </Card>
                </div>
            </Body>
        </>
    );
};

export default Tools;
